/* global SWDLocalise */
import { getClosest, handleResponse, loaderHTML } from '../../utils';

let searchInstance;
let isLoading = false;
let brandSelectInput;
let modelSelectInput;
let yearSelectInput;
let modelVariantInput;
const searchForm = document.querySelector('.js-m-search');
const modelDefault = '<option value="" selected disabled>Model</option>';
const yearDefault = '<option value="" selected disabled>Year</option>';
const modelVariantDefault = '<option value="" selected disabled>Model Variant</option>';
const runflatInput = '<input type="hidden" name="runflat" value="true">';

const disableLoader = () => {
    searchForm.querySelectorAll('.js-loader').forEach((el) => el.remove());
    isLoading = false;
};

const enableLoader = () => {
    if (isLoading) return;

    const response = searchForm.querySelector('.js-m-search-response');
    if (response) response.remove();

    searchForm.insertAdjacentHTML('beforeend', loaderHTML);
    isLoading = true;
};

const buildForms = (data) => (`
    <div class="p-8 mt-2 border-2 border-light rounded-lg js-m-search-response">
        <h2 class="mb-6 text-2xl/tight font-semibold">Search tyres for a ${data['model-name']}</h2>
        <form
            action="${data.action}"
            method="get">
            <input type="hidden"
                name="section"
                value="${data.front[0].section}">
            <input type="hidden"
                name="profile"
                value="${data.front[0].profile}">
            <input type="hidden"
                name="rim"
                value="${data.front[0].rim}">
            ${data.front[0].runflat === '1' ? '<input type="hidden" name="runflat" value="true">' : ''}
            <input type="hidden"
                name="make"
                value="${data.make}">
            <input type="hidden"
                name="model"
                value="${data.model}">
            <input type="hidden"
                name="model-year"
                value="${data.year}">
            <input type="hidden"
                name="model-variant"
                value="${data['model-variant']}">
            <div class="sm:flex">
                <select class="sm:flex-1 mb-1.5 sm:mb-0 js-m-search-inline-select">
                    ${data.front.map((tyre) => `<option value="${tyre.section}|${tyre.profile}|${tyre.rim}${tyre.runflat === '1' ? '|runflat' : ''}">${tyre.section} | ${tyre.profile} | ${tyre.rim}${tyre.runflat === '1' ? ' | Runflat' : ''}</option>`).join('')}
                </select>
                <button
                    type="submit"
                    class="w-full sm:w-min h-14 mb-2 sm:ml-1.5 px-8 border-2 border-lime bg-lime rounded-lg text-center font-semibold select-none touch-manipulation whitespace-nowrap transition-colors hover:bg-green hover:border-green hover:text-white${searchForm.dataset.inline ? ' js-m-search-inline-btn' : ''}"
                    data-tyre="front">Search ${data.rear.length > 0 ? 'Front ' : ''}Tyres</button>
            </div>
        </form>
        ${data.rear.length > 0 ? `
            <form
                action="${data.action}"
                method="get"
                class="mt-6 sm:mt-1.5">
                <input type="hidden"
                    name="section"
                    value="${data.rear[0].section}">
                <input type="hidden"
                    name="profile"
                    value="${data.rear[0].profile}">
                <input type="hidden"
                    name="rim"
                    value="${data.rear[0].rim}">
                ${data.rear[0].runflat === '1' ? '<input type="hidden" name="runflat" value="true">' : ''}
                <input type="hidden"
                    name="make"
                    value="${data.make}">
                <input type="hidden"
                    name="model"
                    value="${data.model}">
                <input type="hidden"
                    name="model-year"
                    value="${data.year}">
                <input type="hidden"
                    name="model-variant"
                    value="${data['model-variant']}">
                <div class="sm:flex">
                    <select class="sm:flex-1 mb-1.5 sm:mb-0 js-m-search-inline-select">
                        ${data.rear.map((tyre) => `<option value="${tyre.section}|${tyre.profile}|${tyre.rim}${tyre.runflat === '1' ? '|runflat' : ''}">${tyre.section} | ${tyre.profile} | ${tyre.rim}${tyre.runflat === '1' ? ' | Runflat' : ''}</option>`).join('')}
                    </select>
                    <button
                        type="submit"
                        class="w-full sm:w-min h-14 mb-2 sm:ml-1.5 px-8 border-2 border-lime bg-lime rounded-lg text-center font-semibold select-none touch-manipulation whitespace-nowrap transition-colors hover:bg-green hover:border-green hover:text-white${searchForm.dataset.inline ? ' js-m-search-inline-btn' : ''}"
                        data-tyre="rear">Search Rear Tyres</button>
                </div>
            </form>
        ` : ''}
    </div>
`);

const buildErrorMessage = () => (`
    <div class="p-8 mt-2 border-2 border-light rounded-lg js-m-search-response">
        <h2 class="mb-2 text-2xl/tight font-semibold">Sorry, there's been an issue</h2>
        <p>Please try again or try searching using your vehicles number plate.</p>
    </div>
`);

const handleInlineSelectInputs = () => {
    document.querySelectorAll('.js-m-search-inline-select').forEach((select) => {
        select.addEventListener('change', (event) => {
            const [section, profile, rim, runflat] = event.target.value.split('|');
            const parent = getClosest(select, 'form');

            const hasRunflatInput = parent.querySelector('[name="runflat"]');
            if (hasRunflatInput) hasRunflatInput.remove();

            parent.querySelector('[name="section"]').value = section;
            parent.querySelector('[name="profile"]').value = profile;
            parent.querySelector('[name="rim"]').value = rim;

            if (runflat !== undefined) {
                parent.insertAdjacentHTML('beforeend', runflatInput);
            }
        });
    });
};

const handleInlineBtns = () => {
    const searchResults = document.querySelector('.js-search-results');

    document.querySelectorAll('.js-m-search-inline-btn').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();

            const parent = getClosest(btn, 'form');
            const tyre = parent.querySelector('.js-m-search-inline-select').value.split('|');

            searchInstance.helper
                .clearRefinements()
                .toggleFacetRefinement('section', tyre[0])
                .toggleFacetRefinement('profile', tyre[1])
                .toggleFacetRefinement('rim', tyre[2]);

            if (tyre[3] !== undefined) {
                searchInstance.helper.toggleFacetRefinement('runflat', true);
            }

            // preselect season
            if (searchResults
                && searchResults.dataset.season !== undefined) {
                searchInstance.helper
                    .clearRefinements('taxonomies.tyre_season')
                    .toggleFacetRefinement('taxonomies.tyre_season', searchResults.dataset.season);
            }

            // preselect type
            if (searchResults
                && searchResults.dataset.type !== undefined) {
                searchInstance.helper
                    .clearRefinements('taxonomies.tyre_type')
                    .toggleFacetRefinement('taxonomies.tyre_type', searchResults.dataset.type);
            }

            searchInstance.helper.search();

            // switch tab
            document.querySelector('.js-tab-btn').click();
        });
    });
};

const updateSelectInputs = (name, data) => {
    switch (name) {
        case 'make':
            // reset
            modelSelectInput.innerHTML = modelDefault;
            yearSelectInput.innerHTML = yearDefault;
            modelVariantInput.innerHTML = modelVariantDefault;

            if (searchForm.dataset.inline) {
                const searchResults = document.querySelector('.js-search-results');

                searchInstance.helper.clearRefinements();

                // preselect season
                if (searchResults
                    && searchResults.dataset.season !== undefined) {
                    searchInstance.helper
                        .clearRefinements('taxonomies.tyre_season')
                        .toggleFacetRefinement('taxonomies.tyre_season', searchResults.dataset.season);
                }

                // preselect type
                if (searchResults
                    && searchResults.dataset.type !== undefined) {
                    searchInstance.helper
                        .clearRefinements('taxonomies.tyre_type')
                        .toggleFacetRefinement('taxonomies.tyre_type', searchResults.dataset.type);
                }

                searchInstance.helper.search();
            }

            // add options
            data.options.forEach((model) => {
                modelSelectInput.add(new Option(model.label, model.value));
            });
            break;
        case 'model':
            // reset
            yearSelectInput.innerHTML = yearDefault;
            modelVariantInput.innerHTML = modelVariantDefault;

            // add options
            data.options.forEach((year) => {
                yearSelectInput.add(new Option(year.label, year.value));
            });
            break;
        case 'year':
            // reset
            modelVariantInput.innerHTML = modelVariantDefault;

            // add options
            data.options.forEach((modelVariant) => {
                modelVariantInput.add(new Option(modelVariant.label, modelVariant.value));
            });
            break;
        case 'model-variant':
            searchForm.insertAdjacentHTML('beforeend', buildForms(data));

            if (searchForm.dataset.inline) {
                handleInlineBtns();
            } else {
                handleInlineSelectInputs();
            }
            break;

        // no default
    }
};

const selectHandle = (event) => {
    enableLoader();

    const data = new FormData();
    data.append('action', searchForm.dataset.action);
    data.append('nonce', searchForm.dataset.nonce);
    data.append('step', event.target.getAttribute('name'));
    data.append('make', brandSelectInput.value);
    data.append('model', modelSelectInput.value);
    data.append('year', yearSelectInput.value);
    data.append('model-variant', modelVariantInput.value);

    fetch(SWDLocalise.ajaxUrl, {
        method: 'POST',
        cache: 'no-cache',
        body: data,
    })
        .then(handleResponse)
        .then((response) => {
            if (response.success) {
                updateSelectInputs(event.target.getAttribute('name'), response.data);
            } else {
                searchForm.insertAdjacentHTML('beforeend', buildErrorMessage());
            }

            disableLoader();
        })
        .catch((error) => {
            console.error(error); // eslint-disable-line no-console
            searchForm.insertAdjacentHTML('beforeend', buildErrorMessage());
            disableLoader();
        });
};

const init = (search) => {
    if (!searchForm) return;

    const selectInputs = searchForm.querySelectorAll('.js-m-search-select');
    selectInputs.forEach((input) => {
        input.addEventListener('change', selectHandle);
    });

    brandSelectInput = searchForm.querySelector('.js-m-search-select[name="make"]');
    modelSelectInput = searchForm.querySelector('.js-m-search-select[name="model"]');
    yearSelectInput = searchForm.querySelector('.js-m-search-select[name="year"]');
    modelVariantInput = searchForm.querySelector('.js-m-search-select[name="model-variant"]');

    searchInstance = search;
};

export default init;
